import { Profile } from '~/helpers/userProfile';

// Id do cliente aberto no Painel, como chega da rota ou do estado.
export type PanelClientId = number | string | null | undefined;

// Diel e o Admin de Conta daquele cliente gerenciam o Painel completo: criam, excluem e editam
// todos os cadastros. Fonte única da regra no Painel — não recalcular nos componentes.
// O Admin de Conta é decidido pelo perfil no próprio cliente ([ADMC], ou [ADMCAD] nos subclientes
// da conta), como no API-Server: isAdminConta vale para a sessão inteira (basta [ADMC] em qualquer cliente).
export function canManageWholePanel(profile: Profile, clientId: PanelClientId): boolean {
  if (profile.manageAllClients) return true;
  if (clientId == null) return false;
  const permsOnClient = profile.permissions.PER_CLIENT?.find((x) => x.clientId === Number(clientId));
  return !!permsOnClient?.p.some((x) => x === '[ADMC]' || x === '[ADMCAD]');
}

// O modo restrito vale só para o Admin de cliente que recebeu a opção de editar cadastros
// naquele cliente; quem gerencia o Painel completo nunca fica restrito.
export function isRegistryEditRestricted(profile: Profile, clientId: PanelClientId): boolean {
  if (clientId == null || canManageWholePanel(profile, clientId)) return false;
  return profile.adminClientEdit?.CLIENT_MANAGE.includes(Number(clientId)) ?? false;
}

// Quem pode editar cadastros no Painel: o Painel completo ou o modo restrito.
export function canEditRegistry(profile: Profile, clientId: PanelClientId): boolean {
  return canManageWholePanel(profile, clientId) || isRegistryEditRestricted(profile, clientId);
}

// Admin do cliente ([C] no nível do cliente) sem a opção de editar cadastros: no Painel de unidades
// só pode alterar a Saúde no Controle Inteligente, e nenhum outro cadastro. Como no API-Server
// (isRegistryRestrictedClientAdmin), quem também é Instalador ([I]) no cliente não entra nas restrições
// de Admin do cliente (Conta, [ADMC]/[ADMCAD], já sai em canEditRegistry).
export function isHealthRemoteControlOnlyEdit(profile: Profile, clientId: PanelClientId): boolean {
  if (clientId == null || canEditRegistry(profile, clientId)) return false;
  const permsOnClient = profile.permissions.PER_CLIENT?.find((x) => x.clientId === Number(clientId));
  return !!permsOnClient?.p.includes('[C]') && !permsOnClient.p.includes('[I]');
}

// Quem pode alterar a Saúde no Controle Inteligente de uma unidade: quem edita cadastros ou o admin do cliente sem [CE].
export function canEditHealthRemoteControl(profile: Profile, clientId: PanelClientId): boolean {
  return canEditRegistry(profile, clientId) || isHealthRemoteControlOnlyEdit(profile, clientId);
}
